var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmileyIdBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 260 155",
    xmlSpace: "preserve",
    width: 260,
    height: 155,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\r\n    .st0{fill:#5b82ff}.st8{fill:#b7b7b7}.st10{fill:#fff;stroke:#5b82ff;stroke-width:2;stroke-miterlimit:10}\r\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g9405",
    transform: "translate(-618.44 -791.374)",
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1472",
    transform: "translate(103.657 1033.33)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 707.25,
    cy: -173.92,
    r: 64.72,
    id: "circle1456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.18-173.92c0 22.6-18.32 40.93-40.93 40.93s-40.93-18.32-40.93-40.93",
    id: "path1458",
    fill: "none",
    stroke: "#5b82ff",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1462"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m682.93-179.44.76-8.4-6.97 4.87-3.82-6.68 7.63-3.53-7.63-3.53 3.82-6.68 6.97 4.87-.76-8.4h7.64l-.76 8.4 6.97-4.87 3.82 6.68-7.64 3.53 7.64 3.53-3.82 6.68-6.97-4.87.76 8.4z",
    id: "path1460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1468"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m728.79-179.44.76-8.4-6.97 4.87-3.82-6.68 7.63-3.53-7.63-3.53 3.82-6.68 6.97 4.87-.76-8.4h7.64l-.76 8.4 6.97-4.87 3.82 6.68-7.64 3.53 7.64 3.53-3.82 6.68-6.97-4.87.76 8.4z",
    id: "path1466"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1486",
    transform: "translate(103.657 1033.33)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M637.61-97.31H535.03c-8.15 0-14.75-6.6-14.75-14.75v-46.52c0-8.15 6.6-14.75 14.75-14.75h102.59c8.15 0 14.75 6.6 14.75 14.75v46.52c-.01 8.15-6.61 14.75-14.76 14.75z",
    id: "path1474"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 555.82,
    cy: -174.4,
    r: 7.79,
    id: "circle1476"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 571.41,
    cy: -174.4,
    r: 7.79,
    id: "circle1478"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 587,
    cy: -174.4,
    r: 7.79,
    id: "circle1480"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 602.59,
    cy: -174.4,
    r: 7.79,
    id: "circle1482"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 599.41,
    cy: -98.05,
    r: 7.79,
    id: "circle1484"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1522",
    transform: "translate(103.657 1033.33)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    id: "rect1488",
    d: "M533.66-159.58h45.05v46.71h-45.05z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1506"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 555.33,
    cy: -136.19,
    r: 14.12,
    id: "circle1490",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.26-136.19c0 4.93-4 8.93-8.93 8.93s-8.93-4-8.93-8.93",
    id: "path1492",
    fill: "none",
    stroke: "#b7b7b7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1496"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m550.02-137.39.17-1.83-1.52 1.06-.83-1.46 1.67-.77-1.67-.77.83-1.46 1.52 1.06-.17-1.83h1.67l-.17 1.83 1.52-1.06.83 1.46-1.67.77 1.67.77-.83 1.46-1.52-1.06.17 1.83z",
    id: "path1494"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1502"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m560.02-137.39.17-1.83-1.52 1.06-.83-1.46 1.67-.77-1.67-.77.83-1.46 1.52 1.06-.17-1.83h1.67l-.17 1.83 1.52-1.06.83 1.46-1.67.77 1.67.77-.83 1.46-1.52-1.06.17 1.83z",
    id: "path1500"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    id: "rect1508",
    d: "M589.01-159.58h49.97v14.16h-49.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    id: "rect1510",
    d: "M589.01-138.8h22.37v4.84h-22.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    id: "rect1512",
    d: "M589.01-117.71h22.37v4.84h-22.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    id: "rect1514",
    d: "M589.01-128.25h22.37v4.84h-22.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    id: "rect1516",
    d: "M616.61-138.8h22.37v4.84h-22.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    id: "rect1518",
    d: "M616.61-117.71h22.37v4.84h-22.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    id: "rect1520",
    d: "M616.61-128.25h22.37v4.84h-22.37z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyIdBg);
export default __webpack_public_path__ + "static/media/smiley-id-bg.cd9d0f8ff255e64c11746c96fc640d82.svg";
export { ForwardRef as ReactComponent };